"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArcadianCommunitiesRebalanced = void 0;
var Card_1 = require("../../Card");
var SelectSpace_1 = require("../../../inputs/SelectSpace");
var CardName_1 = require("../../../CardName");
var CardType_1 = require("../../CardType");
var CardRenderer_1 = require("../../render/CardRenderer");
var Size_1 = require("../../render/Size");
var Resources_1 = require("../../../Resources");
var Tags_1 = require("../../Tags");
var ArcadianCommunitiesRebalanced = (function (_super) {
    __extends(ArcadianCommunitiesRebalanced, _super);
    function ArcadianCommunitiesRebalanced() {
        return _super.call(this, {
            cardType: CardType_1.CardType.CORPORATION,
            name: CardName_1.CardName.ARCADIAN_COMMUNITIES_REBALANCED,
            startingMegaCredits: 42,
            tags: [Tags_1.Tags.BUILDING],
            initialActionText: 'Place a community (player marker) on a non-reserved area',
            metadata: {
                cardNumber: 'R44',
                description: 'You start with 42 M€, 10 steel and 1 steel production. AS YOUR FIRST ACTION, PLACE A COMMUNITY [PLAYER MARKER] ON A NON-RESERVED AREA.',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.br;
                    b.megacredits(42).steel(10).digit.production(function (pb) { return pb.steel(1); }).nbsp.community().asterix();
                    b.corpBox('action', function (ce) {
                        ce.text('ACTION: PLACE A COMMUNITY (PLAYER MARKER) ON A NON-RESERVED AREA ADJACENT TO ONE OF YOUR TILES OR MARKED AREAS', Size_1.Size.TINY, true);
                        ce.vSpace(Size_1.Size.MEDIUM);
                        ce.text('EFFECT: MARKED AREAS ARE RESERVED FOR YOU. WHEN YOU PLACE A TILE THERE, GAIN 3 M€', Size_1.Size.TINY, true);
                    });
                }),
            },
        }) || this;
    }
    ArcadianCommunitiesRebalanced.prototype.initialAction = function (player) {
        return new SelectSpace_1.SelectSpace('Select space for claim', player.game.board.getAvailableSpacesOnLand(player), function (foundSpace) {
            foundSpace.player = player;
            player.game.log('${0} placed a Community (player marker)', function (b) { return b.player(player); });
            return undefined;
        });
    };
    ArcadianCommunitiesRebalanced.prototype.canAct = function (player) {
        return player.game.board.getAvailableSpacesForMarker(player).length > 0;
    };
    ArcadianCommunitiesRebalanced.prototype.action = function (player) {
        return new SelectSpace_1.SelectSpace('Select space for claim', player.game.board.getAvailableSpacesForMarker(player), function (foundSpace) {
            foundSpace.player = player;
            return undefined;
        });
    };
    ArcadianCommunitiesRebalanced.prototype.play = function (player) {
        player.steel = 10;
        player.addProduction(Resources_1.Resources.STEEL, 1);
        return undefined;
    };
    return ArcadianCommunitiesRebalanced;
}(Card_1.Card));
exports.ArcadianCommunitiesRebalanced = ArcadianCommunitiesRebalanced;
//# sourceMappingURL=ArcadianCommunitiesRebalanced.js.map